import { productsApi } from "@dashboard/products/api";
import { Build } from "@dashboard/products/types";

type Artifact = Build["artifacts"][number];

const isUploadedFirmware = (artifact: Artifact) => artifact.type === "os-firmware" && artifact.isUploaded;

export const getFirmwareArtifacts = (build: Build) => (build.artifacts ?? []).filter(isUploadedFirmware);

export const getFirmwareDownloads = (build: Build) =>
    getFirmwareArtifacts(build).reduce((sum, artifact) => sum + artifact.downloads, 0);

export const countDownloads = (build: Build, artifactIds: number[]) =>
    productsApi.util.updateQueryData("fetchProductBuilds", build.productId, (builds) => {
        builds
            .find((item) => item.buildId === build.buildId)
            ?.artifacts.filter((artifact) => artifactIds.includes(artifact.id))
            .forEach((artifact) => {
                artifact.downloads += 1;
            });
    });
